import styled from "styled-components";

export const AboutParticipantWrapper = styled.div`
  .about-participant {
    padding: 16px 0px 24px 16px;
  }

  .about-textfield {
    width: 60%;
  }
`;
